import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const FilterWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '20px 20px',
  borderRadius: '8px',
  marginBottom: '16px',
});
